module.exports = __webpack_public_path__ + "media/images/honeycomb-banner-1583e68036b5a586797f77e24cf2595f.svg";